import { createClient } from 'next-sanity'

import { apiVersion, dataset, previewDrafts, projectId, readToken } from '../env'
import { resolveSanityClientConfig } from './client-config'

// Production keeps useCdn: false (unchanged). When SANITY_PREVIEW_DRAFTS is set, the
// resolver switches to the drafts perspective with the read token and forces useCdn: false.
export const client = createClient(
  resolveSanityClientConfig({
    projectId,
    dataset,
    apiVersion,
    useCdn: false,
    previewDrafts,
    readToken,
  }),
)
